const settingsPreferences = {
  computed: {
    settings() {
      return this.$store.getters.company.settings;
    }
  },
  watch: {
    settings: {
      async handler() {
        await this.$apiCall(`mutation SettingsPreference($input:CompanySettingsInput!) {
                              companySettingsSet(input:$input) {
                                id
                              }
                            }`,
                            {input:this.settings});
      },
      immediate: false,
      deep: true
    }
  }
}

export default settingsPreferences;